import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PreviewState {
  device?: string;
}

const initialState: PreviewState = {};

export const previewSlice = createSlice({
  name: "preview",
  initialState,
  reducers: {
    setDevice: (state, action: PayloadAction<string>) => {
      state.device = action.payload;
    },
  },
});

export const { setDevice } = previewSlice.actions;

export default previewSlice.reducer;
